import {
  Dashboard,
  People,
  Inventory2,
  ShoppingCart,
  Notifications,
  Settings,
  Payment,
} from '@mui/icons-material';

export const navigationConfig = [
  {
    title: 'navigation.dashboard',
    path: '/',
    icon: <Dashboard />,
  },
  {
    title: 'navigation.users',
    path: '/users',
    icon: <People />,
  },
  {
    title: 'navigation.containers',
    path: '/lockers',
    icon: <Inventory2 />,
  },
  {
    title: 'navigation.orders',
    path: '/orders',
    icon: <ShoppingCart />,
  },
  {
    title: 'Transactions',
    path: '/payment-history',
    icon: <Payment />,   // ✅ Perfect
  },
  {
    title: 'navigation.notifications',
    path: '/notifications',
    icon: <Notifications />,
  },
  {
    title: 'navigation.settings',
    path: '/settings',
    icon: <Settings />,
  },

];
